import styles from '@styles/components/build-your-own/find-favorite-product/index.module.scss';
import {useRef} from "react";
import {useInView} from "framer-motion";
import Link from 'next/link'

// @ts-ignore
export const FindFavoriteProduct = ({pdfDetails}) => {

    // these variables are used to animate the left and right image when this view are on screen.
    const ref = useRef(null);
    const isInView = useInView(ref, {once: false});

    /**
     * in this section user can download the pdf file of the products.
     */
    return (
        <section className={styles.find_your_products} ref={ref}>
            <div className={`images ${isInView ? 'image_animation' : ''}`}>
                <img className={'desktop'} src="/assets/images/decorations/build_your_own/build_your_own_page_left.webp"
                     alt="download catalog"/>
                <img className={'desktop'} src="/assets/images/decorations/build_your_own/build_your_own_page_right.webp"
                     alt="download catalog"/>
                <img className={'ipad'} src="/assets/images/decorations/build_your_own/build_your_own_ipad_left.webp" alt="download catalog"/>
                <img className={'ipad'} src="/assets/images/decorations/build_your_own/build_your_own_ipad_right.webp"
                     alt="download catalog"/>
                <img className={'mobile'} src="/assets/images/decorations/build_your_own/build_your_own_mobile_left.webp" alt="download catalog"/>
                <img className={'mobile'} src="/assets/images/decorations/build_your_own/build_your_own_mobile_right.webp"
                     alt="download catalog"/>
            </div>
            <div className={'container'}>
                <span className={`title_bold`}>
                        find your favorite <br/>products
                    </span>
                {
                    pdfDetails.Products_Catalog && pdfDetails.Products_Catalog.data && pdfDetails.Products_Catalog.data.attributes &&
                <Link href={pdfDetails.Products_Catalog.data.attributes.url} className={'download_catalog'}
                      target={"_blank"} download={'SIDR Products Catalog'}>
                    download catalog
                </Link>
                }
            </div>
        </section>
    )
}
